<template>
	<sf-data-table
		ref="PartCostTable"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="partCostCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		@changedRow="changedRow"
		@row-click="rowClick"
		fit="fit"
		creatable
		index
	>
		<template v-slot:actionsLeft> </template>
		<template v-slot:actionsRight>
			<!--엑셀업로드-->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
			<!--엑셀템플릿 다운-->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="downExcelTemp"> {{ getMessage_('QWCC001799') }} </sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as yup from 'yup';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.gridList;
		},
		partCostCols() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					width: '160px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'partNm',
					width: '290px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000958'), // 협력사
					prop: 'cpnyCd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001342'), // 협력사명
					prop: 'cpnyNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001924'), // 실납품사
					prop: 'dlvgNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001167'), // 시작일
					prop: 'strtDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000954'), // 종료일
					prop: 'endDd',
					width: '130px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC000973'), // 기종
					prop: 'tymaNm',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001168'), // 분담율
					prop: 'rtsh',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001165'), // 부품원가
					prop: 'partCst',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001182'), // 협력사 보증조건
					width: '200px',
					align: 'center',
					sortable: false,
					children: [
						{
							label: this.getMessage_('QWCC001351'), // 보증기간(년)
							prop: 'usePrd',
							width: '110px',
							headerAlign: 'center',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001023'), // 보증사용거리(만Km)
							prop: 'milg',
							minWidth: '110px',
							headerAlign: 'center',
							align: 'right'
						}
					]
				}
			];
		},
		partExcelCostCols() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					width: '80px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'partNm',
					width: '150px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000958'), // 협력사
					prop: 'cpnyCd',
					width: '50px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001342'), // 협력사명
					prop: 'cpnyNm',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001924'), // 실납품사
					prop: 'dlvgNm',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001167'), // 시작일
					prop: 'strtDd',
					width: '60px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000954'), // 종료일
					prop: 'endDd',
					width: '60px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC000973'), // 기종
					prop: 'tymaNm',
					width: '70px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001168'), // 분담율
					prop: 'rtsh',
					width: '50px',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001165'), // 부품원가
					prop: 'partCst',
					width: '100px',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001351'), // 보증기간(년)
					prop: 'usePrd',
					width: '50px',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001023'), // 보증사용거리(만Km)
					prop: 'milg',
					width: '70px',
					align: 'right'
				}
			];
		},
		insVali() {
			return yup.array().of(
				yup.object().shape({
					partsNo: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000904')]))
				})
			);
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001398'), //타이틀바 값 PMC No 엑셀 업로드
				apiGubun: 'PART_COST', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
				//param1: '' //
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				stdDt: this.searchParams.stdDt,
				partNo: this.searchParams.partNo,
				cpnyCd: this.searchParams.cpnyCd,
				partScn: this.searchParams.partScn,
				dlvgNm: this.searchParams.dlvgNm,
				partG: this.searchParams.partG,
				authCode: this.authCode
			});

			const url = `${BASE_URL}/comm/qmsbase/partCost/v1/partCosts/excel` + queryStr;

			const params = { url, columns: this.partExcelCostCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		downExcelTemp() {
			let params = {
				apiGubun: 'PART_COST'
			};

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},

		changedRow({ rows, changedRow }) {
			let tmpStatus = changedRow.tableState;

			if (tmpStatus !== 'I') {
				changedRow.tableState = 'U';
			}
		},
		rowClick(row) {
			let rowClickData = _.cloneDeep(row);
			//console.log('rowClickData', rowClickData);
			this.setState_({ key: 'masterInfo', value: rowClickData });
		}
	}
};
</script>

<style></style>
